import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {StrategyPayload, getAuthorizationStrategy} from '../../services/endpoints'
import { NetworkRequestError, RequestErrorResponse } from '../../services/lib'
import { PayloadAction, isRejected } from '@reduxjs/toolkit'

const sliceName = 'strategies'
export interface StrategyItem {
  id: string
  name: string
}

export interface StrategyState {
  form: boolean
  sso: StrategyItem[]
  allow_register_users: boolean
  allow_lost_password: boolean
  loading: boolean
  error: NetworkRequestError | null
}

//everything set to false, except for loading, in production
const initialState: StrategyState = {
  form: false,
  sso: [],
  allow_register_users: false,
  allow_lost_password: false,
  loading: true,
  error: null
}

export const getStrategies = createAsyncThunk(
  `${sliceName}/authservices`,
  async (_, { rejectWithValue }) => {
    try {
      //like this to catch thrown data
      return await getAuthorizationStrategy()
    } catch (err:unknown) {
      return rejectWithValue(err)
    }
  }
)

export const strategySlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getStrategies.fulfilled, (state, action) => {
        state.loading = false
        state.form = action.payload.form
        state.sso = action.payload.sso
        state.allow_lost_password = action.payload.allow_lost_password
        state.allow_register_users = action.payload.allow_register_users
        state.error = null
      })
      .addCase(getStrategies.pending, (state, _action) => {
        state.loading = true
        state.error = null
      })
      .addMatcher(
        isRejected,
        (
          state,
          action: PayloadAction<NetworkRequestError>
        ) => {
          if (sliceName === action.type.split('/')[0]) {
            state.loading = false
            state.error = action.payload
          }
        }
      )
  },
})

